/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { PaymentLogDto } from "../models/index";
import { PaymentLogDtoFromJSON, PaymentLogDtoToJSON } from "../models/index";

/**
 *
 */
export class PaymentLogHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Query payment log. Requires Permission.user_tasks_read
     */
    async paymentLogsODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<PaymentLogDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/payment-logs-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(PaymentLogDtoFromJSON),
        );
    }

    /**
     * Query payment log. Requires Permission.user_tasks_read
     */
    async paymentLogsOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<PaymentLogDto>> {
        const response = await this.paymentLogsODataRaw(initOverrides);
        return await response.value();
    }
}
